import { useTranslation } from "@emisgroup/acp-application-intl";
import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useUser } from "../../../../AuthContext";
import { IRootState } from "../../../../reducer/CombineReducer";
import { ExtractOnSubmitProps } from "../../../LeftPanel/ExtractAdd/IExtractCreateOrUpdateProps";
import { ExtractModes } from "../../../LeftPanel/ExtractAdd/redux/Types";
import { onSubmit } from "../../../LeftPanel/ExtractAdd/script";
import { INotification } from "../../../Notification/Index";
import { SaveExtractDetailView } from "./SaveExtractDetail.view";

interface ISaveExtractProps {
  /**
   * Reverts the changes when clicking cancel
   */
  cancel: () => void;
  /**
   * Success or Failure notification
   */
  notification: INotification;
}

/**
 * Returns the save extract footer content
 */
export const SaveExtractDetail = (props: ISaveExtractProps): JSX.Element => {
  const { cancel, notification } = props;
  const [isDisabled, setIsDisabled] = useState(false);
  const [
    extractAdd,
    yearsState,
    extractState
  ] = useSelector((state: IRootState) => [
    state.extractAdd,
    state.yearsState,
    state.extractState
  ], shallowEqual);
  const isViewMode = extractAdd.mode === ExtractModes.VIEW;
  const isEmptyExtractName = Boolean(extractAdd.newExtract.title);
  const { user } = useUser();
  const mode = extractAdd.mode;
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  // Check to enable/disable the save button based on form input data
  const checkToEnableDisableSaveButton = (): boolean => {
    return extractAdd.editExtractDetail.title.value === "" ||
    extractAdd.editExtractDetail.schema?.errorText !== "" ||
    extractAdd.editExtractDetail.survey?.errorText !== "";

  };

  React.useEffect(() => {
    const isToDisabled = isViewMode || checkToEnableDisableSaveButton() || !isEmptyExtractName;
    setIsDisabled(isToDisabled);
  }, [isViewMode, isEmptyExtractName, extractAdd.editExtractDetail]);

  const details: ExtractOnSubmitProps = {
    extractAdd,
    year: yearsState.selectedYear,
    notification,
    user,
    translate,
    mode: extractAdd.mode,
    extractState,
  };

  const onClick = (): void => {
    onSubmit(dispatch, details);
  };

  return (
    <SaveExtractDetailView
      cancel={cancel}
      isDisabled={isDisabled}
      onSubmit={onClick}
      mode={mode}
    />
  );
};
